import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonGroup
} from 'reactstrap';

import { LIST } from 'constants/dashboard';

import DashboardMetricsApi from 'apis/DashboardMetrices';

import ListConfiguration from './configuration-elements/ListConfiguration';

class ListConfigModal extends Component {
  constructor() {
    super();
    this.state = {
      count: '10',
      order: 'descending',
      size: 'wide',
      type: 'total',
      removeConfigModal: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { editComponentId, isVisible } = nextProps;

    if (!isVisible) return;

    if (editComponentId) {
      DashboardMetricsApi.getDetails(editComponentId).then(({ data }) => {
        const { dashboard_config } = data;
        const { component_config, record_config } = dashboard_config;

        this.setState({
          count: record_config && record_config.count,
          type: record_config && record_config.type,
          size: component_config && component_config.size,
          order: component_config && component_config.order
        });
      });
    }
  }

  onDataChange = (key, value) => {
    this.setState({
      [key]: value
    })
  }

  save = () => {
    const data = this.configurationObj();
    const width = 3;
    const height = 10;

    const { editComponentId, saveMetricConfig, addNewMetric } = this.props;

    if (editComponentId) {
      const dataWithId = { ...data, id: this.props.editComponentId }
      saveMetricConfig(dataWithId)
    } else {
      addNewMetric(data, width, height)
    }
  }

  configurationObj = () => {
    const { count, type, size, order } = this.state;
    const { configModalTitle } = this.props;

    return {
      type: LIST,
      metric: configModalTitle,
      record_config: {
        type,
        count
      },
      component_config: {
        size,
        order
      }
    };
  }

  remove = () => {
    this.props.toggleRemoveConfigModal(this.props.editComponentId);
  }

  render() {
    const {
      isVisible, toggleModal, editComponentId, configModalTitle
    } = this.props;
    const { type, size, order, count } = this.state;

    const buttonText = editComponentId ? 'Save Component' : 'Add Component';

    return (
      <React.Fragment>
        <Modal className="select-metrics-modal" isOpen={isVisible} toggle={toggleModal}>
          <ModalHeader>
            <div className="metric-title">
              <div className="metric-action d-inline">
                <FontAwesomeIcon icon="calculator" />
              </div>
              Configure - {configModalTitle}
            </div>
          </ModalHeader>
          <ModalBody>
            <ListConfiguration onDataChange={this.onDataChange} count={count} order={order} size={size} type={type} />
          </ModalBody>
          <ModalFooter className="d-block">
            {
              editComponentId && <Button className="btn-remove mt-2" onClick={this.remove}>
                <span className="ml-2">
                  <FontAwesomeIcon icon="times-circle" />
                </span>
                Remove
              </Button>
            }
            <ButtonGroup className="float-right">
              <Button className="btn-cancel" onClick={toggleModal}>Cancel</Button>
              <Button className="btn-add" onClick={this.save}>{buttonText}</Button>
            </ButtonGroup>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

ListConfigModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  editComponentId: PropTypes.string,
  configModalTitle: PropTypes.string,
};

ListConfigModal.defaultProps = {
  editComponentId: undefined,
  configModalTitle: undefined,
};

export default ListConfigModal;



// WEBPACK FOOTER //
// ./src/components/dashboard/list/ListConfigModal.js